import { render, staticRenderFns } from "./Logout.vue?vue&type=template&id=4d06e869&scoped=true"
import script from "./Logout.vue?vue&type=script&lang=js"
export * from "./Logout.vue?vue&type=script&lang=js"
import style0 from "./Logout.vue?vue&type=style&index=0&id=4d06e869&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d06e869",
  null
  
)

export default component.exports